const loginInitialValues = {
  username: "",
  password: "",
};

export default loginInitialValues;
